import { injectable } from 'inversify';
import values from 'lodash/values';
import { Permission } from '../../constants/Permission';
import { PermissionsProvider } from './PermissionsProvider';

@injectable()
export class MutablePermissionsProvider implements PermissionsProvider {
  static allEnabled(): MutablePermissionsProvider {
    return new MutablePermissionsProvider(values<Permission>(Permission));
  }

  private _permissions: Set<Permission>;

  constructor(permissions: Array<Permission | null> = []) {
    this.reset(permissions);
  }

  hasPermission(permission: Permission): boolean {
    return this._permissions.has(permission);
  }

  enable(permission: Permission): this {
    this._permissions.add(permission);

    return this;
  }

  disable(permission: Permission): this {
    this._permissions.delete(permission);

    return this;
  }

  toggle(permission: Permission, enabled: boolean): this {
    if (enabled) {
      return this.enable(permission);
    } else {
      return this.disable(permission);
    }
  }

  reset(permissions: Array<Permission | null> = []): this {
    this._permissions = new Set(permissions.filter((item) => item !== null) as Array<Permission>);

    return this;
  }
}
